export default __webpack_public_path__ + "static/media/s1.85c23b13.png";